import config from './config.js'

export default {

  actives: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/actives','Laufende Prozesse laden',cb_success);
  },

  killproc: function(ctrl,id,msg,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/kill?pid=' + encodeURIComponent(id) + '&msg=' + encodeURIComponent(msg),'Prozess anhalten',cb_success);
  },

  definitions: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/definitions','Prozessdefinitionen laden',cb_success);
  },

  loaddef: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/repository/' + encodeURIComponent(id),'Prozessdefinition laden',cb_success);
  },

  loaddefxml: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/repository/' + encodeURIComponent(id) + '?xml=1','Prozessdefinition laden',cb_success,'text');
  },

  deletedef: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/wf/repository/' + encodeURIComponent(id),'Prozessdef. Version löschen',cb_success);
  },

  history: function(ctrl,id,from,to,cb_success) {
    config.get(ctrl,
      config.baseUrl + 'rest/wf/process/history?id=' + encodeURIComponent(id) + '&from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to),
      'Prozesshistorie laden',
      cb_success);
  },

  historyEntry: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/result?eid=' + encodeURIComponent(id),'Prozesslauf laden',cb_success);
  },

  historyTasks: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/result/tasks?piid=' + encodeURIComponent(id),'Prozessaufgaben laden',cb_success);
  },

  upload: function(files) {
    var fd = new FormData();
    fd.append('filename',files[0]);
    return fetch(config.baseUrl + 'rest/wf/repository',{method:'POST',credentials:'include',body: fd });
  },

  loadforms: function(ctrl,pid,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/forms/' + encodeURIComponent(pid),'Prozessformulare laden',cb_success);
  },

  loadformprops: function(ctrl,key,tid,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/forms/' + encodeURIComponent(key) + '/' + encodeURIComponent(tid),'Prozessformulare Eigenschaften laden',cb_success);
  },

  listformlinks: function(ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/formlinks','Formular-Links laden',cb_success);
  },

  saveformlink: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/wf/formlinks','Formular-Links speichern',JSON.stringify(data),cb_success);
  },

  deleteformlink: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/wf/formlinks/' + encodeURIComponent(id),'Formular-Links löschen',cb_success);
  },

  loadformlink: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/formlinks/' + encodeURIComponent(id),'Formular-Link laden',cb_success);
  },

  loadresultpreview: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/wf/process/dataviews/' + encodeURIComponent(id),'Prozess Preview laden',cb_success,'json',true);
  },

  saveresultpreview: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/wf/process/dataviews/','Prozess Preview speichern.',JSON.stringify(data),cb_success);
  }
}
